/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Analytics_Engagement_ReadInputs */



/**
* | output |
* | --- |
* | "Engagement analytics" |
*
* @param {Perm_Product_Analytics_Engagement_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_analytics_engagement_read = /** @type {((inputs?: Perm_Product_Analytics_Engagement_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Analytics_Engagement_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аналитика вовлечённости")
	return /** @type {LocalizedString} */ ("Engagement analytics")
});